import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './CategorySection.css';

export const SEGMENTS = [  
  {  
    id: "gold",  
    name: "Gold",  
    description: "24K, 22K, 18K gold jewellery with BIS hallmarking",  
    icon: "🪙",  
    color: "var(--gold-400, var(--brand-gold-400))",  
    kind: "product",  
    operator: {  
      capabilities: ["BIS Hallmarking", "Purity Assay", "Weight Audit"],  
      action: "Verify Quality",  
    },  
  },  
  {  
    id: "silver",  
    name: "Silver",  
    description: "999 fine silver, 925 sterling silver jewellery",  
    icon: "⚪",  
    color: "#cbd5e1",  
    kind: "product",  
    operator: {  
      capabilities: ["999 Purity Check", "925 Assay", "Tarnish Test"],  
      action: "Verify Quality",  
    },  
  },  
  {  
    id: "platinum",  
    name: "Platinum",  
    description: "Pt 950 high purity platinum creations",  
    icon: "🔷",  
    color: "#7dd3fc",  
    kind: "product",  
    operator: {  
      capabilities: ["Pt 950 Assay", "Purity Verification", "Density Test"],  
      action: "Verify Quality",  
    },  
  },  
  {  
    id: "diamond",  
    name: "Diamond",  
    description: "Natural diamonds with IGI/GIA certification",  
    icon: "💎",  
    color: "#a5b4fc",  
    kind: "product",  
    operator: {  
      capabilities: ["IGI/GIA Verify", "4C Grading", "Laser Inscription"],  
      action: "Verify Quality",  
    },  
  },  
  {  
    id: "gem",  
    name: "GEM",  
    description: "Precious gemstones: Ruby, Emerald, Sapphire",  
    icon: "💠",  
    color: "#5eead4",  
    kind: "product",  
    operator: {  
      capabilities: ["Gem Grading", "Origin Certificate", "Treatment Check"],  
      action: "Verify Quality",  
    },  
  },  
  {  
    id: "pearl",  
    name: "PEARL",  
    description: "Freshwater, South Sea & Basra cultured pearls",  
    icon: "⚪",  
    color: "#fbcfe8",  
    kind: "product",  
    operator: {  
      capabilities: ["Luster Grading", "Size Sort", "Authenticity Test"],  
      action: "Verify Quality",  
    },  
  },  
  {  
    id: "bandhel",  
    name: "BANDHEL",  
    description: "Heritage craft & wirework jewellery",  
    icon: "🔗",  
    color: "#fcd34d",  
    kind: "product",  
    operator: {  
      capabilities: ["Craft Audit", "Wirework QC", "Heritage Cert"],  
      action: "Verify Quality",  
    },  
  },  
  {  
    id: "decor",  
    name: "DECOR",  
    description: "Showroom displays, trays & packaging materials",  
    icon: "📦",  
    color: "#d8b4fe",  
    kind: "service",  
    operator: {  
      capabilities: ["Display QC", "Packaging Audit", "Material Spec"],  
      action: "Audit Quality",  
    },  
  },  
  {  
    id: "brand",  
    name: "BRAND",  
    description: "Jewellery branding, packaging & marketing services",  
    icon: "🏷️",  
    color: "#fdba74",  
    kind: "service",  
    operator: {  
      capabilities: ["Brand Compliance", "Marketing Audit", "Asset Review"],  
      action: "Review Brand",  
    },  
  },  
  {  
    id: "tool",  
    name: "TOOL",  
    description:  
      "Jewellery tools: Bench tools, polishing, assaying equipment",  
    icon: "🔧",  
    color: "#f59e0b",  
    kind: "equipment",  
    operator: {  
      capabilities: ["Tool Calibration", "Assay Cert", "Equipment QC"],  
      action: "Calibrate Tools",  
    },  
  },  
  {  
    id: "machine",  
    name: "MACHINE",  
    description: "Jewellery machinery: CNC, laser, casting equipment",  
    icon: "⚙️",  
    color: "#94a3b8",  
    kind: "equipment",  
    operator: {  
      capabilities: ["Machine Inspection", "CNC Calibration", "Safety Cert"],  
      action: "Inspect Machine",  
    },  
  },  
];

const CategorySection = () => {
  const [selectedCategory, setSelectedCategory] = useState(0);

  const categories = [
    {
      id: 'gold',
      name: 'Gold Jewellery',
      purities: '24K (999) | 22K (916) | 18K (750)',
      description: 'Handcrafted chains, bangles, bridal sets, casting necklaces, and lightweight daily wear with BIS hallmarking.',
      imgUrl: 'https://images.openai.com/static-rsc-4/KdoU_MhHYSmJwzIFtLDIhOS24f9eLf9TDiqpLULeS3YP55ACf3HkEb5ZCgJiS2PouLWHOooIukLthzqeSH5GNoUIRZANRBO5drVAMUPRhzp4wA5Liuy5qnP72zEOFI4050CwN0NeQFtavPfoH4Du7NXoIRQSJVVHOrZ0KKVfbx6_GENeUgPndkVZYSU8XnrG?purpose=fullsize',
      minOrder: '50 grams',
      hallmark: 'BIS HUID Certified',
      popular: 'Temple & Antique Jewellery',
    },
    {
      id: 'silver',
      name: 'Silver Jewellery & Bullion',
      purities: '999 Fine Silver | 92.5 Sterling',
      description: 'Anklets (Payal), silver utensils, gift articles, idols, Italian machine chains, and certified silver bullion bars.',
      imgUrl: 'https://images.openai.com/static-rsc-4/Dlprdz5ucv52HiZgwS1QeQOdd-yeZxsC_1J8D8z1-HgbY5Ed60RIHrsRxb8csIjoyLfO9q_53af6NdtA3VuviKlelx20ww2cUnq0henpIixx6MC_6dyRlL-G4Pw5ry8wzYeAK8NLSJIxNxTzdipMPP2Gs3jZL8ULORTLiwbm_-Ssl7XTuVp4FR7hT12UpSQx?purpose=fullsize',
      minOrder: '500 grams',
      hallmark: '925 Hallmarked',
      popular: 'Payals & Silver Idols',
    },
    {
      id: 'diamond',
      name: 'Diamond Solitaires & Ornaments',
      purities: 'VVS-VS / EF-GH in 14K & 18K Gold',
      description: 'Certified natural diamonds, solitaires, tennis bracelets, cocktail rings, and bridal sets with international grading.',
      imgUrl: 'https://images.openai.com/static-rsc-4/SChE8xeqK1hSH0MCGBR9SFTEhHXvDE8gT_4fot-zGEysH1FmFv8zzMH5v-VPFsrCv1g1LCe3rpU-FWTWMiV2fXZRd8c8BuysEv4daGIWPv5LlomcKcyI-G17zzkS2FyoJfbMrbZfRB-LmAue5DRTbg_aOyA1Jzn2LohB2VAEmB1667koW9kpxT9Ptr-MXtTs?purpose=fullsize',
      minOrder: '₹1,50,000 Lot',
      hallmark: 'IGI / GIA Certified',
      popular: 'Solitaire Rings & Tennis Necklaces',
    },
    {
      id: 'platinum',
      name: 'Platinum Creations',
      purities: 'Pt 950 High Purity',
      description: 'Contemporary couple bands, men\'s chains, kadas, and diamond-studded platinum rings.',
      imgUrl: 'https://images.openai.com/static-rsc-4/hz8EuP7qS8VznAO474f0Vl8DPjIix_w8vJ1K89own4MaU7uvZO_yBbeO5Ic9z1YXCFudrlkNRAleUN1wx2J_5CWBv6FL7vd1fgXL5CpiJpwZ_6E2AsYcYL7onRikSiY-E66e8DZvzS11JhAw6uf5CSvA2QgBrEFmMvZBe_ID8xsIPguXl5-kclq81FR-rr2i?purpose=fullsize',
      minOrder: '25 grams',
      hallmark: 'PGI Guild Certified',
      popular: 'Love Bands & Executive Men\'s Chains',
    },
    {
      id: 'gemstone',
      name: 'Precious Gemstones',
      purities: 'Natural Certified & Untreated',
      description: 'Rubies, Emeralds, Sapphires, Navratna sets, and astrology-grade certified single stones in calibrated cuts.',
      imgUrl: 'https://images.openai.com/static-rsc-4/PC1dfmBFnFbMba90JuInVHlTGoYvQhVRQckYgb3tHMZ4D1HyKnN0dE6q8Aos5r4jrDtodS4bdXWfPTbCcjLuKtKzTX_EE7tgjvjZdK9dxUHXRbk2pYU66FiBbsFGyZhJSWixCDONwFSSyNTAyHS7zALcf0kLtVgMoqY20Y2KdADtf4YE_ZrHXUI5P8B_nKXf?purpose=fullsize',
      minOrder: '20 Carats',
      hallmark: 'Lab Origin Certified',
      popular: 'Zambian Emeralds & Burmese Rubies',
    },
    {
      id: 'pearl',
      name: 'Pearl Jewellery',
      purities: 'Freshwater, South Sea & Basra',
      description: 'Cultured pearl strands, polki pearl combinations, hyderabadi choker sets, and drop earrings.',
      imgUrl: 'https://images.openai.com/static-rsc-4/8tMSuTCwuPRvxZVnVFmbRSh6KZtKBK2Yfd8eyF6XcluNKB8TqVoGLNjFqnPJ4s5mH9znNupY7YMQMAF2_-BSq4wwPCAIo_zCPKosgYjibBvfMvxcKY_zqjsbhaCSCKH32fXLLdSHFbm-jyGKPlw1p3twmWkYLot92T5uu4xZYmPONX1vM50dvdWdYj4T0RAo?purpose=fullsize',
      minOrder: '10 Strands / Sets',
      hallmark: 'Gemmological Grade',
      popular: 'South Sea Pearl Necklaces',
    },
  ];

  return (
    <section className="categories-section" id="categories">
      <div className="jmi-container">
        <div className="section-header-center">
          <div className="section-label">WHOLESALE CATALOGUES</div>
          <h2 className="section-title">
            Explore <span className="gold-gradient-text">Wholesale Categories</span>
          </h2>
          <p className="section-subtitle">
            Source high-turnover jewellery categories backed by standardised weight tolerances,
            verified purity hallmarks, and transparent making charge structures.
          </p>
        </div>

        {/* Category Pills Navigation */}
        <div className="category-tabs-bar">
          {categories.map((cat, idx) => (
            <button
              key={cat.id}
              className={`cat-tab-btn ${selectedCategory === idx ? 'active' : ''}`}
              onClick={() => setSelectedCategory(idx)}
            >
              {cat.name.split(' ')[0]}
            </button>
          ))}
        </div>

        {/* Active Category Showcase */}
        <div className="category-spotlight-card">
          <div className="spotlight-image-col">
            <img 
              src={categories[selectedCategory].imgUrl} 
              alt={categories[selectedCategory].name} 
              className="category-hero-img"
              loading="lazy"
            />
            <div className="image-overlay-badge">
              <span className="badge-hallmark">{categories[selectedCategory].hallmark}</span>
            </div>
          </div>

          <div className="spotlight-content-col">
            <div className="spotlight-meta-top">
              <span className="cat-badge">VERIFIED CATEGORY</span>
              <span className="min-order-pill">Min Wholesale Lot: {categories[selectedCategory].minOrder}</span>
            </div>

            <h3 className="spotlight-title">{categories[selectedCategory].name}</h3>
            <div className="spotlight-purities">
              <span className="label">Purity Tiers:</span>
              <span className="val">{categories[selectedCategory].purities}</span>
            </div>

            <p className="spotlight-desc">{categories[selectedCategory].description}</p>

            <div className="spec-tiles-grid">
              <div className="spec-tile">
                <span className="spec-tile-label">Popular Segment</span>
                <span className="spec-tile-value">{categories[selectedCategory].popular}</span>
              </div>
              <div className="spec-tile">
                <span className="spec-tile-label">Pricing Base</span>
                <span className="spec-tile-value">Live Bullion + Making Charge</span>
              </div>
              <div className="spec-tile">
                <span className="spec-tile-label">Assay Quality</span>
                <span className="spec-tile-value">{categories[selectedCategory].hallmark}</span>
              </div>
              <div className="spec-tile">
                <span className="spec-tile-label">Transit Coverage</span>
                <span className="spec-tile-value">100% Insured Logistics</span>
              </div>
            </div>

            <div className="spotlight-actions">
              <Link to="/buyer" className="btn btn-primary">
                Source {categories[selectedCategory].name.split(' ')[0]} Jewellery
              </Link>
              <Link to="/seller" className="btn btn-secondary">
                List as Manufacturer
              </Link>
            </div>
          </div>
        </div>

        {/* Thumbnail grid of all categories */}
        <div className="all-categories-grid">
          {categories.map((cat, idx) => (
            <div 
              key={cat.id} 
              className={`cat-mini-card ${selectedCategory === idx ? 'selected' : ''}`}
              onClick={() => setSelectedCategory(idx)}
            >
              <img src={cat.imgUrl} alt={cat.name} className="cat-mini-img" loading="lazy" />
              <div className="cat-mini-info">
                <h4 className="cat-mini-title">{cat.name}</h4>
                <span className="cat-mini-purity">{cat.purities.split('|')[0]}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
